import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import * as Styled from "./RollAdsList.styled";
import RightArrowIcon from "../../../../../assets/images/icons/arrow-right.svg";
import { ConfirmModal, Switch } from "../../../../../libs";
import { RollAdsModal } from "../../roll-ads-modal";
import deleteIcon from "../../../../../assets/images/delete.svg";
import "react-toastify/dist/ReactToastify.css";
import { IAdServerUpdateCampaignRequestDto, RollAdsListProps } from "../../../../../libs/models/ad-server";
import { adServerService } from "../../../../../services";

export const RollAdsList: React.FC<RollAdsListProps> = ({ campaigns, handleDeleteCampaign, fetchCampaigns }) => {
  const [campaignStates, setCampaignStates] = useState<Record<string, boolean>>(
    campaigns.reduce((acc, campaign) => ({ ...acc, [campaign.campaignId]: campaign.visibility }), {})
  );
  const [selectedCampaignId, setSelectedCampaignId] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [campaignList, setCampaignList] = useState(
    [...campaigns]
      .filter((c) => c.createdAt)
      .sort((a, b) => new Date(b.createdAt!).getTime() - new Date(a.createdAt!).getTime())
  );
console.log("Campaign", campaignList);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [deletingCampaignId, setDeletingCampaignId] = useState<string | null>(null);

  const handleCardClick = (campaignId: string) => {
    setSelectedCampaignId(campaignId);
    setIsModalOpen(true);
  };

  const confirmDelete = (campaignId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setDeletingCampaignId(campaignId);
    setIsConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (deletingCampaignId) {
      await handleDeleteCampaign(deletingCampaignId);
      setIsConfirmOpen(false);
      setDeletingCampaignId(null);
    }
  };

  const handleCampaignToggle = async (
    campaignId: string,
    event: React.MouseEvent | React.ChangeEvent
  ) => {
    event.stopPropagation();

    try {
      const newVisibilityState = !campaignStates[campaignId];

      // Optimistically update the state
      setCampaignStates((prev) => ({
        ...prev,
        [campaignId]: newVisibilityState,
      }));

      // Construct the payload with only visibility
      const updatePayload: IAdServerUpdateCampaignRequestDto = {
        visibility: newVisibilityState,
      };

      // API call to update visibility
      await adServerService.updateCampaigns(campaignId, updatePayload);
      fetchCampaigns();

    } catch (error) {
      console.error("Error updating campaign visibility:", error);

      // Revert state if API fails
      setCampaignStates((prev) => ({
        ...prev,
        [campaignId]: !prev[campaignId],
      }));
    }
  };

  return (
    <Styled.ListContainer>
      <Row>
        {campaignList.map((campaign) => (
          <Col md={6} key={campaign.campaignId}>
            <Styled.CampaignCard onClick={() => handleCardClick(campaign.campaignId)}>
              <Styled.CampaignHeader>
                <Styled.TitleContainer>
                  <Styled.CampaignTitle>
                    {campaign.title} <Styled.VideoText>{campaign.videos}</Styled.VideoText>
                  </Styled.CampaignTitle>
                  <Styled.ArrowIcon src={RightArrowIcon} alt="Arrow Right" />
                </Styled.TitleContainer>

                <Styled.ActionContainer>
                  <Switch
                    checked={campaignStates[campaign.campaignId]}
                    onChange={(event) => handleCampaignToggle(campaign.campaignId, event)}
                    onClick={(event) => event.stopPropagation()}
                  />
                  <Styled.DeleteIcon
                    src={deleteIcon}
                    alt="Delete"
                    onClick={(e) => confirmDelete(campaign.campaignId, e)}
                  />
                </Styled.ActionContainer>
              </Styled.CampaignHeader>
              <Styled.Categories>{campaign.categories.join(" | ")}</Styled.Categories>
            </Styled.CampaignCard>
          </Col>
        ))}

        {isModalOpen && (
          <RollAdsModal show={isModalOpen} isEdit={true} onClose={() => setIsModalOpen(false)} campaignId={selectedCampaignId} fetchCampaigns={fetchCampaigns} />
        )}

        {isConfirmOpen && (
          <Styled.ConfirmModalWrapper>
            <ConfirmModal
              title="Confirm Item Removal"
              description={[
                { text: "Are you sure you want to remove this item?", bold: false },
                { text: "This operation is permanent and cannot be reverted.", bold: true },
              ]}
              noText="No"
              yesText="Yes, Delete it!"
              onNo={() => setIsConfirmOpen(false)}
              onYes={handleConfirmDelete}
              danger
            />
          </Styled.ConfirmModalWrapper>
        )}
      </Row>
    </Styled.ListContainer>
  );
};
